// ** React Imports
import { useHistory } from "react-router-dom";

// ** Redux
import { useDispatch, useSelector } from "react-redux";
import { openAuthModal } from "store/modules/global-common.slice";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import { CardWrapper } from "components/layout/Card/CardWrapper";
import { CardBody } from "components/layout/Card/CardBody";
import { CardTitle } from "components/layout/Card/CardTitle";
import { CardFooter } from "components/layout/Card/CardFooter";
import { Media } from "components/media";
import Heading from "components/typography/HeadingLink";
import ShowMoreLink from "components/layout/ShowMoreLink";

// ** Utils & Helpers
import generatePath from "utils/generatePath";

// ** Routes
import containers from "containers";

// ** Styled Components
import { StyledPicturesList } from "./styles";
import Block from "components/layout/Block";

// #####################################################

const Gallery = ({ galleryLoaded, galleryData, login }) => {
	const dispatch = useDispatch();
	const history = useHistory();

	const { t } = useTranslation(["userProfile"]);

	const isAuth = useSelector((state) => state.globalCommon.isAuth);

	const to = generatePath("/users/:login/gallery", {
		login: login.toLowerCase(),
	});

	// #####################################################

	return (
		<CardWrapper>
			<CardTitle>
				<Heading noPadding type="h2" to={to}>
					{t("userGallery")}
				</Heading>
			</CardTitle>
			<CardBody noPaddingXmobile>
				{galleryLoaded ? (
					<StyledPicturesList>
						{galleryData &&
							galleryData.length > 0 &&
							galleryData.map((item) => {
								const to = isAuth
									? generatePath(containers.modal.path, {
											contentId: item.id,
											login: login?.toLowerCase(),
											type: item.media_type,
									  })
									: "/";

								return (
									<Block
										key={item.id}
										onClick={() => {
											if (!isAuth) {
												dispatch(openAuthModal());
											} else {
												history.push({
													hash: to,
												});
											}
										}}
									>
										<Media
											thumbnail={
												item.media.square ||
												item.media.thumbs.poster_square
											}
											sourceFull={item.media?.video}
											sourcePreview={
												item.media?.thumbs
													?.preview_square
											}
											type={item.media_type}
											alt="Photo in gallery"
											iconSize="userprofile_gallery"
											iconCenter
											isSquared
											zoom
										/>
									</Block>
								);
							})}
					</StyledPicturesList>
				) : null}
			</CardBody>
			<CardFooter>
				<ShowMoreLink to={to} />
			</CardFooter>
		</CardWrapper>
	);
};

export default Gallery;

// #####################################################
